import { isNil, isNull } from 'lodash-es'

import { TaxReceiptType, TReceiptInformation } from '@/entities/user'

import { TReceiptInformationFormValues } from './form'

export const defaultReceiptInformation = {
  receiptRequested: null,
  taxReceiptType: null,
  issuanceNumber: '',
  corpId: '',
  corpName: '',
  corpCeo: '',
  invoiceeEmail: '',
}

export const convertFormValuesToReceiptInformation = (
  formValues: TReceiptInformationFormValues,
): TReceiptInformation => {
  if (isNull(formValues.receiptRequested)) {
    return defaultReceiptInformation
  }

  if (formValues.receiptRequested === 'false') {
    return {
      ...defaultReceiptInformation,
      receiptRequested: false,
    }
  }

  if (formValues.taxReceiptType === TaxReceiptType.CASH_RECEIPT_PERSONAL) {
    return {
      ...defaultReceiptInformation,
      receiptRequested: true,
      taxReceiptType: TaxReceiptType.CASH_RECEIPT_PERSONAL,
      issuanceNumber: formValues.personalIssuanceNumber?.trim() || '',
    }
  }

  if (formValues.taxReceiptType === TaxReceiptType.CASH_RECEIPT_BUSINESS) {
    return {
      ...defaultReceiptInformation,
      receiptRequested: true,
      taxReceiptType: TaxReceiptType.CASH_RECEIPT_BUSINESS,
      issuanceNumber: formValues.businessIssuanceNumber?.trim() || '',
    }
  }

  return {
    ...defaultReceiptInformation,
    receiptRequested: true,
    taxReceiptType: TaxReceiptType.TAX_INVOICE,
    corpId: formValues.corpId?.trim() || '',
    corpName: formValues.corpName?.trim() || '',
    corpCeo: formValues.corpCeo?.trim() || '',
    invoiceeEmail: formValues.invoiceeEmail?.trim() || '',
  }
}

export const convertReceiptInformationToFormValues = (
  receiptInformation?: Omit<
    TReceiptInformation,
    'isEditAvailable' | 'status' | 'failedReason' | 'billUrl'
  > | null,
): TReceiptInformationFormValues | null => {
  if (isNil(receiptInformation)) {
    return null
  }

  const receiptRequested = (() => {
    if (receiptInformation.receiptRequested === true) {
      return 'true'
    }

    if (receiptInformation.receiptRequested === false) {
      return 'false'
    }

    return null
  })()

  const isBusiness =
    receiptInformation.taxReceiptType === TaxReceiptType.CASH_RECEIPT_BUSINESS
  const isPersonal =
    receiptInformation.taxReceiptType === TaxReceiptType.CASH_RECEIPT_PERSONAL

  return {
    receiptRequested,
    taxReceiptType: receiptInformation.taxReceiptType,
    businessIssuanceNumber: isBusiness
      ? (receiptInformation.issuanceNumber ?? '')
      : '',
    personalIssuanceNumber: isPersonal
      ? (receiptInformation.issuanceNumber ?? '')
      : '',
    corpId: receiptInformation.corpId ?? '',
    corpName: receiptInformation.corpName ?? '',
    corpCeo: receiptInformation.corpCeo ?? '',
    invoiceeEmail: receiptInformation.invoiceeEmail ?? '',
  }
}
